import { render } from "./ProformaList.vue?vue&type=template&id=49f73a7c&scoped=true"
import script from "./ProformaList.vue?vue&type=script&lang=js"
export * from "./ProformaList.vue?vue&type=script&lang=js"

import "./ProformaList.vue?vue&type=style&index=0&id=49f73a7c&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f73a7c"]])

export default __exports__